// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1BXwD","insightsList":"newBusinessInsightsMenu_insightsList__3WlCH","active":"newBusinessInsightsMenu_active__7VIZX"};